<template>
    <v-container fluid>
        <role-crud></role-crud>
    </v-container>
</template>

<script>
    import RoleCrud from "./RoleCrud";

    export default {
        name: "RolePage",
        components: {RoleCrud},

    }
</script>

<style scoped>

</style>

